export default __webpack_public_path__ + "7cb4fbf72dc4a4f1b9a1f754a82e2550.svg";